import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmptyCartIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.8327 11.7425V10.0015V6.90557H18.7511V10.0015H7.90169V2.0695C7.90169 1.71035 7.75902 1.36591 7.50507 1.11196C7.25111 0.858003 6.90667 0.715332 6.54753 0.715332H0.166016V3.81045H4.82096V11.7425C4.82096 12.1016 4.96363 12.4461 5.21759 12.7C5.47155 12.954 5.81598 13.0966 6.17513 13.0966H20.4785C20.8377 13.0966 21.1821 12.954 21.4361 12.7C21.69 12.4461 21.8327 12.1016 21.8327 11.7425ZM21.834 16.9829C21.8423 15.7036 20.8119 14.6598 19.5325 14.6515C18.2532 14.6432 17.2094 15.6736 17.2012 16.953C17.1929 18.2323 18.2233 19.2761 19.5026 19.2844C20.782 19.2926 21.8258 18.2622 21.834 16.9829ZM7.1538 19.2848C8.43313 19.2768 9.46371 18.2332 9.45567 16.9539C9.44763 15.6745 8.40402 14.644 7.12469 14.652C5.84537 14.66 4.81479 15.7037 4.82282 16.983C4.83086 18.2623 5.87448 19.2929 7.1538 19.2848Z",
		fill: "currentColor"
	})
});
export default SvgEmptyCartIcon;
